import React, { useContext, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import NotAuthorized from '../Common/NotAuthorized';

const PrivateRoute = ({ children, role = null }) => {
  const { currentUser, userProfile, loading } = useContext(AuthContext);
  const [showNotAuthorized, setShowNotAuthorized] = useState(false);
  const [redirectPath, setRedirectPath] = useState('/dashboard');

  // Réinitialiser l'état quand le composant est monté
  useEffect(() => {
    setShowNotAuthorized(false);
  }, []);

  if (loading) {
    return <div className="loading-screen">Chargement...</div>;
  }

  // Vérifier si l'utilisateur est connecté
  if (!currentUser) {
    // Ouvrir le modal de connexion
    setTimeout(() => {
      window.openAuthModal && window.openAuthModal();
    }, 100);
    return <Navigate to="/" />;
  }

  // Vérifier le rôle si nécessaire
  if (role && userProfile?.role !== role) {
    // Déterminer le chemin de redirection approprié
    let redirectTo = '/dashboard';
    
    if (role === 'admin' && userProfile?.role !== 'admin') {
      // Pour la route /admin, si l'utilisateur n'est pas admin
      console.log("Accès non autorisé à la page admin. Redirection...");
      if (userProfile?.role === 'practitioner') {
        redirectTo = '/practitioner';
      } else {
        redirectTo = '/dashboard';
      }
    } else if (role === 'practitioner' && userProfile?.role !== 'practitioner') {
      // Pour la route /practitioner, si l'utilisateur n'est pas un praticien
      if (userProfile?.role === 'admin') {
        redirectTo = '/admin';
      } else {
        redirectTo = '/dashboard';
      }
    }
    
    // Afficher le composant NotAuthorized avant la redirection
    return <NotAuthorized redirectTo={redirectTo} />;
  }

  // Si tout est OK, afficher le composant enfant
  return children;
};

export default PrivateRoute;